import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import MarketSnapshotsDataPreferences from 'lumen/components/market/snapshots/data-preferences';
import MarketSnapshotsPage from 'lumen/components/market/snapshots/page';
import MarketSnapshotsTableLayout from 'lumen/components/market/snapshots/table-layout';
import type MarketSnapshotsTransientGroupController from 'lumen/controllers/market/snapshots/transient-group';
import type MarketSnapshotsTransientGroupRoute from 'lumen/routes/market/snapshots/transient-group';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSnapshotsTransientGroupSignature {
  Args: {
    controller: MarketSnapshotsTransientGroupController;
    model: ModelFrom<MarketSnapshotsTransientGroupRoute>;
  };
}

<template>
  <MarketSnapshotsPage
    @dates={{@controller.dates}}
    @kpiSection={{@controller.kpiSection}}
    @pagination={{@controller.pagination}}
    @table={{@controller.table}}
    @title={{t "market.snapshots.view.transient_group"}}
    @view="transient-group"
  >
    <:controls>
      <MarketSnapshotsDataPreferences
        @dataPreferences={{@controller.dataPreferences}}
        @onSave={{@controller.updateDataPreferences}}
        @showForecastColumn={{false}}
        @showSdlyColumn={{true}}
        class="ms-auto"
      />
    </:controls>

    <:tableControls>
      <MarketSnapshotsTableLayout
        @hideGroupColumnsBy={{@controller.config.columns.categoriesOnly}}
        @manageColumns={{hash
          fixed=@controller.config.columns.fixed
          kpiSettings=@controller.kpiColumnSettings
          metrics=@controller.columnMetrics
          settings=@controller.columnSettings
        }}
        @onSave={{@controller.updateTableLayoutPreferences}}
        @tableLayoutPreferences={{@controller.layout}}
      />
    </:tableControls>
  </MarketSnapshotsPage>
</template> satisfies TOC<MarketSnapshotsTransientGroupSignature>;
